module.exports = __webpack_public_path__ + "static/selim-chehimi-418f2708c303f5c1475753f2f87d379b.jpg";